import React from 'react';

const BuildingIcon = () => (
  <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M10.8327 9.16667H14.8327C15.7661 9.16667 16.2328 9.16667 16.5893 9.34832C16.9029 9.50811 17.1579 9.76308 17.3177 10.0767C17.4993 10.4332 17.4993 10.8999 17.4993 11.8333V17.5M10.8327 17.5V5.16667C10.8327 4.23325 10.8327 3.76654 10.651 3.41002C10.4912 3.09641 10.2363 2.84144 9.92267 2.68166C9.56615 2.5 9.09944 2.5 8.16602 2.5H5.16602C4.23259 2.5 3.76588 2.5 3.40936 2.68166C3.09576 2.84144 2.84079 3.09641 2.681 3.41002C2.49935 3.76654 2.49935 4.23325 2.49935 5.16667V17.5M18.3327 17.5H1.66602M5.41602 5.83333H7.91602M5.41602 9.16667H7.91602M5.41602 12.5H7.91602" stroke="black" strokeWidth="1.66667" strokeLinecap="round" strokeLinejoin="round"/>
  </svg>
);

export default BuildingIcon;
